<template>
    <div>
        <MercenaryHeader :title="title" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <InfinityScroll style="overflow:auto; flex:1; padding:0px 12px; " :style="{ backgroundColor: this.mode === MY_CLASS_RESERVATION_MODE.CLOSE ? 'white' : '#ebebeb' }" :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage">
            <template v-if="is_loaded">
                <template v-if="join_schedules.length > 0">
                    <template v-if="this.mode === MY_CLASS_RESERVATION_MODE.CLOSE">
                        <div style="color:#606060; font-size:12px; padding:10px 0px; padding-top: 20px;">눌러서 상세정보를 확인할 수 있습니다.</div>
                        <div v-for="each, i in join_schedules" :key="i" class="short_row_wrap" @click="showTeamTrainingDetail(each.idx)">
                            <div>
                                <span style="color:#210F03; font-size:14px; font-weight:500;">{{ $Util.getMMDDDayHangulStr(each.join_begin_date_time) }} {{ each.begin_time }}~{{ each.end_time }}</span>
                                <span v-if="each.state == '0' && each.payment && each.payment[0] && each.payment[0].state == '0'" style="float:right; color:#808080; font-size:14px; font-weight:bold;">예약</span>
                                <span v-else-if="each.payment && each.payment[0] && each.payment[0].state == '2'" style="float:right; font-size:14px; font-weight:bold; color:red;">취소</span>
                                <span v-else style="float:right; color:#808080; font-size:14px; font-weight:bold;">종료</span>
                            </div>
                            <div style="font-size: 16px; color:#210F03; font-weight: 500; margin-top:10px;">{{ each.title }}</div>
                            <div v-if="!each.is_with_review_history" @click.stop="sendReview(each)" style="font-weight: 500; font-size: 15px; line-height: 24px; color: #4b8aff; margin-top: 8px;">후기 보내기</div>
                            <div v-else @click.stop="showReviewHistory(each)" style="font-weight: 500; font-size: 15px; line-height: 24px; color: #4b8aff; margin-top: 8px;">내가 보낸 후기</div>
                        </div>
                    </template>
                    <template v-else>
                        <div style="height:12px;"></div>
                        <div v-for="each, i in join_schedules" :key="i" class="row_wrap" @click="showTeamTrainingDetail(each.idx)">
                            <div class="row_header">
                                <!-- <div>
                                    <img :src="require('@/assets/img/team_training_title.png')" style="height:20px;">
                                </div> -->
                                <div style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: 0;" v-if="each.image_list.length > 0">
                                    <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + each.image_list[0].image_path" alt="">
                                </div>
                                <div style="position: relative; z-index: 1;">
                                    <div style="color:white; font-weight:bold; font-size:20px;">{{ each.title }}</div>
                                    <div v-if="each.state == '0' && each.payment && each.payment[0] && each.payment[0].state == '0'" style="color:white; font-weight:500; font-size:16px; margin-top:7px;">예약이 확정됐습니다!</div>
                                    <div v-else-if="each.payment && each.payment[0] && each.payment[0].state == '2'" style="color:white; font-weight:500; font-size:16px; margin-top:7px;">취소된 트레이닝</div>
                                    <div v-else style="color:white; font-weight:500; font-size:16px; margin-top:7px;">종료된 트레이닝</div>
                                </div>
                            </div>
                            <div class="info_wrap" style="">
                                <div class="info_row">
                                    <div class="info_label1">일정</div>
                                    <div class="info_contents">
                                        <div>{{ $Util.getMMDDDayHangulStr(each.join_begin_date_time) }}</div>
                                    </div>
                                </div>
                                <div class="info_row">
                                    <div class="info_label1">시간</div>
                                    <div class="info_contents">
                                        <div>{{ $Util.getAmPmTimeStr(each.begin_time, each.end_time) }}</div>
                                        <div>시작시간 10분전에는 와서 준비해주시기 바랍니다.</div>
                                    </div>
                                </div>
                                <div class="info_row">
                                    <div class="info_label1">장소</div>
                                    <div class="info_contents">
                                        <div>{{ each.place_name }}</div>
                                        <div>{{ each.address }}</div>
                                    </div>
                                </div>
                                <div class="info_row">
                                    <div class="info_label1">코치</div>
                                    <div class="info_contents">
                                        <div>{{ each.creator.nic_name }} 코치</div>
                                    </div>
                                </div>
                            </div>
                            <div style="padding:0px 10px;background-color: white; ">
                                <div style="height:2px;border-bottom: 2px dashed #EBEBEB;width:100%;"></div>
                            </div>

                            <template v-if="is_opens[i]">
                                <div class="info_wrap">
                                    <div style="font-size:14px; font-weight:bold;">트레이닝 참여안내</div>
                                    <div class="info_row" style="margin-top:20px;">
                                        <div class="info_label2">1.</div>
                                        <div class="info_contents2">
                                            <div>시간을 지켜주세요.</div>
                                            <div>매치 당일 취소로 인한 환불은 불가능하여, 다른 회원들에게 불편을 주지 않도록 시간을 잘 지켜주시기 바랍니다.</div>
                                        </div>
                                    </div>
                                    <div class="info_row">
                                        <div class="info_label2">2.</div>
                                        <div class="info_contents2">
                                            <div>꼭 풋살화를 신어야 합니다.</div>
                                            <div>치명적인 부상 및 잔디 손상 등을 방지하기 위해 풋살화 착용은 필수입니다 꼭 풋살화나 운동화를 착용해주시기 바랍니다.</div>
                                        </div>
                                    </div>
                                    <div class="info_row">
                                        <div class="info_label2">3.</div>
                                        <div class="info_contents2">
                                            <div>코치님의 지도를 잘 따라야 합니다.</div>
                                            <div>트레이닝부터 소규모 매치까지 모든 과정에서 코치님이 함께합니다. 코치님의 지도를 잘 따라주시기 바랍니다.</div>
                                        </div>
                                    </div>
                                    <div class="info_row">
                                        <div class="info_label2">4.</div>
                                        <div class="info_contents2">
                                            <div>재미만큼 안전도 중요합니다.</div>
                                            <div>코치님이 함께하더라도 부상은 갑작스레 발생할 수 있습니다. 코치님의 지도를 잘 따라서 안전하게 트레이닝과 매치를 즐기시기 바랍니다.</div>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="each.state == '0' && each.payment && each.payment[0] && each.payment[0].state == '0'">
                                    <div style="padding:0px 10px;background-color: white; ">
                                        <div style="height:2px;border-bottom: 2px dashed #EBEBEB;width:100%;"></div>
                                    </div>
                                    <div style="background-color: white; padding-left:12px; flex-direction: column; padding-top: 20px; padding-bottom: 20px;">
                                        <div @click.stop="showChat(i)" style="font-weight: 500; font-size: 15px; line-height: 24px; color: #4b8aff;">코치님과 채팅하기</div>
                                        <div style="font-size:15px; font-weight: 500; margin-top: 12px; color:var(--color-main);" @click.stop="cancel(each.idx)">예약 취소하기</div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div style="display:flex; flex-direction: row-reverse; align-items: center; background-color: white; height:60px;padding-right:10px;">
                                    <div style="font-size:14px; font-weight:500; color:#210F03; display:flex; align-items: center;" @click.stop="open(i)">펼쳐보기<img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(90deg);margin-left:7px;margin-top:2px;"></div>
                                </div>
                            </template>

                        </div>
                        <div style="height:12px;"></div>
                        <div style="border-radius:12px; height:48px; background-color: white; font-size:14px; font-weight:bold; display: grid; place-items: center; margin-top:12px;" @click="showPrevMyClassReservation">지난 예약내역 보기</div>
                        <div style="height:12px;"></div>
                    </template>

                </template>
                <template v-else>
                    <div style="height:12px;"></div>
                    <div style="padding:20px; color:#210F03; font-size:16px; font-weight:500; background-color: #D9D9D9; border-radius:12px; text-align:center;">
                        <div style="font-weight:bold;">예약내역이 없습니다.</div>
                        <div style="margin-top:7px;">우리 지역에서 진행중인 트레이닝을 찾고</div>
                        <div style="margin-top:7px;">트레이닝에 참여해보세요!</div>
                    </div>

                    <div v-if="mode !== MY_CLASS_RESERVATION_MODE.CLOSE" style="border-radius:12px; height:48px; background-color: white; font-size:14px; font-weight:bold; display: grid; place-items: center; margin-top:12px;" @click="showPrevMyClassReservation">지난 예약내역 보기</div>
                </template>
            </template>
        </InfinityScroll>
    </div>
</template>

<script>
import MercenaryHeader from "../../common/MercenaryHeader";
import { JOIN_SCHEDULE_TYPE, JOIN_STATE, JOIN_CHAT_TYPE, REVIEW_PAGE_TYPE } from "../../../Constants";
import InfinityScroll from "../../common/InfinityScroll";
import ResponseCode from "../../../ResponseCode";

export const MY_CLASS_RESERVATION_MODE = {
    OPEN: 0,
    CLOSE: 1,
    SINGLE: 2
};

export default {
    name: "MyClassReservation",
    components: { InfinityScroll, MercenaryHeader },
    props: {
        mode: {
            type: Number,
            default: MY_CLASS_RESERVATION_MODE.OPEN
        },
        join_schedule_idx: {
            type: [String, Number],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            MY_CLASS_RESERVATION_MODE: MY_CLASS_RESERVATION_MODE,
            title: '',
            join_schedules: [],
            is_opens: [],
            is_loaded: false,
            isEnableNextPageHandle: true,
            page: 1,
            REVIEW_PAGE_TYPE: REVIEW_PAGE_TYPE
        }
    },
    methods: {
        showReviewHistory(scheduleInfo) {
            this.$GlobalStore.addModal('ReviewHistory', { join_schedule_idx: scheduleInfo.idx, reviewPageType: REVIEW_PAGE_TYPE.SENT })
        },
        sendReview(scheduleInfo) {
            this.$GlobalStore.addModal('SendReview', { join_schedule_idx: scheduleInfo.idx, completeAction: this.getMyReservations })
        },
        async showChat(index) {
            await this.$Axios.showPersonalChat(this.join_schedules[index].creator.member_idx, this.join_schedules[index].creator.member_type, JOIN_CHAT_TYPE.SINGLE);
        },
        showTeamTrainingDetail(join_schedule_idx) {
            this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: join_schedule_idx })
        },
        async getMyReservations(isSave) {
            if (isSave) {
                this.join_schedules = []
            }
            this.isEnableNextPageHandle = false;
            const parameters = {};
            if (this.mode === MY_CLASS_RESERVATION_MODE.OPEN) {
                parameters.state = JOIN_STATE.OPEN;
            } else if (this.mode === MY_CLASS_RESERVATION_MODE.CLOSE) {
                parameters.state = JOIN_STATE.CLOSE;
            }

            parameters.is_open = '1';
            parameters.filter = 'joined_all';
            parameters.sort = 'new';
            parameters.type = JOIN_SCHEDULE_TYPE.LESSON_SCHEDULE;
            parameters.page = this.page;
            parameters.is_with_review_history = true
            parameters.is_with_creator = true;
            parameters.is_with_image_list = true
            if (this.join_schedule_idx != -1) parameters.join_schedule_idx = this.join_schedule_idx;

            const res = await this.$Axios.get('/api/join/schedule/list', { params: parameters });
            let join_schedules = [];
            if (Array.isArray(res.data.join_schedules)) {
                join_schedules = res.data.join_schedules;
            } else {
                if (res.data.join_schedules) {
                    join_schedules = [res.data.join_schedules];
                }
            }
            // const join_schedules = [...res.data.join_schedules, ...res.data.join_schedules];

            if (join_schedules.length > 0) {
                if (this.mode !== MY_CLASS_RESERVATION_MODE.SINGLE) this.isEnableNextPageHandle = true;
                this.join_schedules = [...this.join_schedules, ...join_schedules];
            }

            //1개 일때는 펼쳐지게
            if (parameters.page === 1 && join_schedules.length === 1) {
                this.is_opens.push(true);
            } else {
                for (const each in res.data.join_schedules) {
                    each;
                    this.is_opens.push(false);
                }
            }

            this.is_loaded = true;
        },
        handleNextPage() {
            this.page++;
            this.getMyReservations();
        },
        open(index) {
            this.$set(this.is_opens, index, true);
        },
        showPrevMyClassReservation() {
            this.$Util.sendEventClick(this.title + '_' + '지난예약내역보기');
            this.$GlobalStore.addModal('MyClassReservation', { mode: MY_CLASS_RESERVATION_MODE.CLOSE })
        },
        cancel(join_schedule_idx) {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">트레이닝 예약 취소하기</div><div style="padding:0px 12px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br>예약은 시작일 자정까지 무료로 취소할 수 있으며,<br> 이후부터는 시간에 따라 환불 비용이 달라집니다.<br>자세한 내용은 규정을 통해 확인해주시기 바랍니다.<br>트레이닝 예약을 취소할까요?</div>`;
            this.$GlobalStore.showConfirm(html, async () => {
                this.$Util.sendEventClick(this.title + '_' + '트레이닝예약취소');
                const parameters = {};
                parameters.join_schedule_idx = join_schedule_idx;

                const res = await this.$Axios.post('/api/join/schedule/exit', parameters)
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.refresh();
                    this.completeAction();
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }, '예약 취소하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
        },
        refresh() {
            this.join_schedules = [];
            this.page = 1;
            this.is_opens = [];
            this.getMyReservations();
        }
    },
    created() {
        this.cancel = this.$Once(this.cancel);
        if (this.mode === MY_CLASS_RESERVATION_MODE.CLOSE) {
            this.title = '지난 예약내역';
        } else {
            this.title = '예약페이지';
        }

        this.getMyReservations();
    }
}
</script>

<style scoped>
.row_header {
    padding: 20px;
    text-align: center;
    /* background: linear-gradient(270deg, #606060 0%, #BBBBBB 100%); */
    position: relative;
}

.row_header.active {
    background: linear-gradient(270deg, rgba(36, 215, 255, 0.6) 0%, rgba(192, 22, 25, 0.6) 100%), linear-gradient(180deg, rgba(70, 96, 145, 0.6) 0%, rgba(255, 17, 21, 0.6) 100%);
}

.row_wrap {
    border-radius: 16px;
    overflow: hidden;
}

.row_wrap+.row_wrap {
    margin-top: 12px;
}

.info_wrap {
    padding: 20px 10px;
    background-color: white;
}

.info_row {
    display: flex;
}

.info_row+.info_row {
    margin-top: 15px;
}

.info_contents>div:nth-of-type(1) {
    color: #210F03;
    font-weight: bold;
    font-size: 16px;
}

.info_contents>div:nth-of-type(2) {
    color: #606060;
    font-weight: 500;
    font-size: 12px;
    margin-top: 5px;
}

.info_contents2>div:nth-of-type(1) {
    color: #210F03;
    font-weight: bold;
    font-size: 14px;
}

.info_contents2>div:nth-of-type(2) {
    color: #606060;
    font-weight: 500;
    font-size: 12px;
    margin-top: 5px;
    line-height: 18px;
}

.info_label1 {
    width: 40px;
    color: #808080;
    font-weight: bold;
    font-size: 12px;
    padding-top: 3px;
}

.info_label2 {
    width: 16px;
    color: #210F03;
    font-weight: bold;
    font-size: 14px;
}

.info_contents {
    flex: 1;
}

.info_contents2 {
    flex: 1;
}


.short_row_wrap {
    padding: 10px 0px;
}

.short_row_wrap+.short_row_wrap {
    border-top: 1px solid rgba(33, 15, 3, 0.1);
}
</style>